import React from 'react';

// Inline vector copy of /public/logo-wordmark.svg — drawn as paths so it stays crisp at any size.
export default function LogoWordmark({ className = '' }) {
  return (
    <svg className={className} viewBox="290 65 1565 200" preserveAspectRatio="xMinYMid meet" aria-hidden="true" focusable="false">
      <g id="wordmark" fill="#B48E7F" transform="translate(0.000000,387.000000) scale(0.100000,-0.100000)">
    <path d="M15923 2970 c-86 -22 -136 -53 -191 -115 -49 -56 -72 -119 -72 -198
0 -89 17 -133 75 -191 67 -69 112 -87 406 -166 124 -33 209 -75 235 -115 50
-76 33 -188 -36 -248 -108 -93 -363 -95 -543 -6 -32 16 -70 38 -84 49 -14 11
-29 20 -34 20 -5 0 -18 -19 -30 -42 l-22 -42 34 -28 c44 -37 143 -84 221 -105
89 -25 311 -24 390 0 193 61 294 223 243 393 -33 113 -132 178 -365 240 -186
49 -240 67 -288 98 -95 60 -110 200 -30 285 43 46 101 70 202 83 105 14 222
-6 332 -56 l72 -34 17 46 c18 45 18 45 -6 63 -31 24 -149 66 -218 79 -85 16
-227 11 -308 -10z"/>
    <path d="M17692 2970 c-181 -48 -315 -156 -395 -320 -55 -111 -73 -204 -63
-322 23 -279 203 -485 484 -553 152 -37 363 -4 500 78 121 72 230 220 267 362
21 84 20 243 -4 333 -55 209 -240 381 -459 427 -100 21 -240 18 -330 -5z m313
-105 c96 -25 165 -64 230 -129 157 -159 190 -406 82 -611 -90 -169 -272 -264
-482 -252 -198 12 -344 105 -425 271 -146 298 10 645 325 722 71 17 200 17
270 -1z"/>
    <path d="M3270 2931 c0 -36 4 -50 17 -55 9 -4 105 -6 212 -6 l196 2 3 -551 2
-551 60 0 60 0 2 551 3 551 187 -2 c240 -1 238 -2 238 61 l0 49 -490 0 -490 0
0 -49z"/>
    <path d="M4460 2375 l0 -605 60 0 60 0 0 280 0 280 385 0 385 0 0 -280 0 -280
60 0 60 0 0 605 0 605 -60 0 -60 0 0 -270 0 -270 -385 0 -385 0 0 270 0 270
-60 0 -60 0 0 -605z"/>
    <path d="M5877 2973 c-4 -3 -7 -276 -7 -605 l0 -598 430 0 430 0 0 55 0 55
-365 0 -365 0 0 225 0 225 315 0 315 0 0 55 0 55 -315 0 -315 0 0 215 c0 165
3 215 13 215 6 0 163 1 347 3 l335 2 3 53 3 52 -409 0 c-225 0 -412 -3 -415
-7z"/>
    <path d="M7300 2931 c0 -34 5 -51 15 -55 8 -3 104 -5 212 -5 l198 0 3 -550 2
-551 60 0 60 0 0 550 0 550 30 0 c17 0 107 1 201 1 93 0 177 3 185 6 9 3 14
21 14 54 l0 49 -490 0 -490 0 0 -49z"/>
    <path d="M8490 2375 l0 -605 60 0 60 0 2 482 3 482 59 -100 c33 -54 91 -153
131 -219 39 -66 120 -204 181 -307 137 -236 132 -234 224 -80 65 108 92 154
235 402 43 74 102 175 131 224 l54 89 0 -486 0 -487 60 0 60 0 0 606 0 605
-52 -3 -53 -3 -140 -242 c-77 -133 -151 -261 -165 -285 -27 -46 -65 -112 -97
-168 -30 -52 -114 -195 -117 -198 -2 -1 -54 84 -116 190 -62 106 -158 270
-213 363 -55 94 -123 209 -151 257 l-51 88 -52 0 -53 0 0 -605z"/>
    <path d="M10155 2968 c-3 -7 -4 -278 -3 -603 l3 -590 285 -3 c338 -3 397 5
536 73 73 36 104 58 157 115 73 77 120 159 142 248 55 227 3 435 -150 588 -78
78 -134 113 -245 152 -74 26 -79 26 -397 30 -263 3 -324 1 -328 -10z m668
-120 c219 -58 347 -234 347 -479 0 -217 -119 -389 -321 -461 -59 -21 -84 -23
-316 -26 l-253 -4 0 499 0 498 233 -3 c195 -3 245 -7 310 -24z"/>
    <path d="M12050 2376 l0 -606 60 0 60 0 0 189 0 188 228 6 c153 4 244 10 279
20 133 38 225 109 278 214 38 74 47 210 21 307 -32 116 -133 214 -266 258 -60
20 -90 22 -362 26 l-298 4 0 -606z m506 490 c185 -7 296 -101 311 -265 11
-124 -34 -226 -128 -283 -71 -44 -158 -58 -376 -58 l-193 0 0 303 c0 167 2
306 5 308 4 5 195 3 381 -5z"/>
    <path d="M13280 2375 l0 -605 60 0 60 0 0 280 0 280 385 0 385 0 0 -280 0
-280 60 0 60 0 0 605 0 605 -60 0 -60 0 0 -270 0 -270 -385 0 -385 0 0 270 0
270 -60 0 -60 0 0 -605z"/>
    <path d="M14480 2975 c0 -5 98 -168 219 -365 19 -30 53 -86 76 -125 23 -38 73
-119 111 -180 l69 -110 3 -212 3 -213 60 0 59 0 0 211 0 211 59 97 c32 53 107
175 166 271 59 96 123 202 142 235 19 33 38 65 43 70 4 6 22 34 39 63 l31 53
-61 -3 -62 -3 -43 -70 c-24 -38 -85 -137 -135 -220 -50 -82 -124 -203 -164
-268 l-74 -119 -24 39 c-14 21 -100 162 -192 313 -222 364 -194 330 -266 330
-32 0 -59 -2 -59 -5z"/>
    <path d="M16810 2375 l0 -605 65 0 65 0 0 605 0 605 -65 0 -64 0 -1 -605z"/>
  </g>
    </svg>
  );
}
